import api from "../utils/api";
import { isGuid } from "../utils/string";
import {
  LOGOUT
} from "./types";


export const get = ({ uuid, personUuid, latest }) => async (dispatch) => {
    try {
        const res = isGuid(uuid) ?
            await api.get(`/people/invoices/i/${uuid}`) :
            await api.get(`/people/invoices/p/${personUuid}/f/${latest}`);
        
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
} 

export const generate = ({ personUuid, staffUuid, applied, payment, remaining }) => async (dispatch) => {
    try {
        const res = await api.post(`/people/invoices/generate`, {
            personUuid,
            staffUuid,
            trustApplied: applied,
            paymentOverride: payment,
            includes: remaining
        });
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const destroy = ({ uuid, activityUuid }) => async (dispatch) => {
    try {
        const res = await api.delete(`/people/invoices${isGuid(activityUuid) ? "/activity" : ""}/i/${ isGuid(uuid) ? uuid : activityUuid }`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}

export const activity = ({ personUuid, from, to, page, size, unbilled }) => async (dispatch) => {
    try {
        const res = await api.get(`/people/invoices/activity/p/${page}/s/${size}/p/${personUuid}/r/${from ?? 0}/${to ?? new Date()}/f/${unbilled}`);
        return res.data;
    } catch (err) {
        dispatch({
            type: LOGOUT
        });
    }
}